export default __webpack_public_path__ + "static/media/changing_1.b5ebc309.jpg";